module.exports = __webpack_public_path__ + "static/img/ourselves1.e5235d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ourselves1.jpg
// module id = mplm
// module chunks = 0